<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <!-- Background decoration -->
    <div class="relative">
      <div class="absolute inset-0 bg-gradient-to-br from-rose-100 to-orange-100 rounded-full blur-3xl opacity-50"></div>
      <div class="relative w-48 h-48 pointer-events-none flex items-center justify-center">
        <LottieComponent
          class="scale-125"
          :src="$constants.TRANSACTIONS.LOTTIES.LOADING_ERROR"
        />
      </div>
    </div>

    <!-- Content -->
    <div class="text-center mt-6">
      <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-rose-500 to-orange-500 shadow-lg mb-4">
        <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h3 class="text-2xl font-bold text-gray-900 mb-2">
        <slot name="errorTitle">Erreur de chargement</slot>
      </h3>
      <p class="text-gray-500 text-lg mb-6 max-w-sm">
        <slot name="errorDescription">
          Une erreur s'est produite lors du chargement
        </slot>
      </p>

      <button
        class="px-6 py-3 bg-gradient-to-r from-rose-500 to-orange-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] flex items-center gap-2 mx-auto"
        @click="$emit('refresh')"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Réessayer
      </button>
    </div>
  </div>
</template>
